// Copyright (c) 2016 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import {
    loadAllAccounts,
    loadAllReturnStatuses,
    loadDefaultRequestDates
} from '../../shared/services/facets-services';
import CheckboxFilterControlled from '../../../shared/components/facets/checkbox-filter/controlled';
import CheckboxWithSearchFilterControlled from '../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../shared/components/facets/facet-footer/index';
import Facets from '../state/facets';
import FacetsDateRangePickerControlled from '../../../shared/components/facets/date-range-picker/controlled';
import RequestTypeFacet from '../../shared/components/request-type-facet';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../shared/services/facets';

function handleDealerFilterInput(text) {

    this.actions.updateDealerAccountFacetInput(text);

}

function handleDealerAccountFacetItem(item, isSelected) {

    this.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handleReturnStatusFacetItem(item, isSelected) {

    this.actions.updateReturnStatusFacetItem(item, isSelected);

}

function toggleReturnStatusFacetItems() {

    this.actions.toggleReturnStatusFacetItems(this.facets.partReturnStatusesFacet.allowedStatuses);

}

function onDatePickerChange(dateRange) {

    this.actions.updateAllPartRequestsDateRangeFacet(dateRange);

}

function toggleDealerAccountFacetItems() {

    this.actions.toggleDealerAccountFacetItems(this.facets.dealerAccountsFacet.allowedDealers);

}

function handleApplyFilters() {

    this.actions.readAllPartRequests(this.facets);

}

function handleResetFilters() {

    this.actions.resetAllFacets(
        this.facets.dealerAccountsFacet.allowedDealers,
        this.facets.partReturnStatusesFacet.allowedStatuses,
        this.facets.requestDateFacet.numberOfDays,
        this.facets.requestTypes.allowedTypes
    );

}

class AllPartsReturnsFacets extends Component {

    state = {
        dateRangePickerExpanded: false,
        dealerLocationExpanded: false,
        requestStatusExpanded: false,
        requestTypeExpanded: false
    };

    componentWillMount() {

        if (loadAllAccounts(this.props.facets.dealerAccountsFacet)) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

        if (loadAllReturnStatuses(this.props.facets.partReturnStatusesFacet)) {

            this.props.actions.selectAllReturnStatusesOnInitialLoad(this.props.facets.partReturnStatusesFacet.allowedStatuses);

        }

        if (loadDefaultRequestDates(this.props.facets.requestDateFacet)) {

            this.props.actions.selectDefaultLoadRequestDates(this.props.facets.requestDateFacet.numberOfDays);

        }

        this.props.actions.getRequestTypes();

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dateRangePickerExpanded || this.state.requestTypeExpanded || this.state.dealerLocationExpanded || this.state.requestStatusExpanded;

    render() {

        return (
            <aside className='all-part-returns-facets'>
                <CheckboxWithSearchFilterControlled
                    initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this.props::handleDealerAccountFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this.props::handleDealerFilterInput}
                    onToggleAll={this.props::toggleDealerAccountFacetItems}
                    searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey='account'
                />
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.facets.partReturnStatusesFacet.selectedStatuses, 'key')}
                    isExpanded={this.state.requestStatusExpanded}
                    list={addCollectionLabels(this.props.facets.partReturnStatusesFacet.allowedStatuses, 'value')}
                    minNumberOfItems={4}
                    onChange={this.props::handleReturnStatusFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'requestStatusExpanded')}
                    onToggleAll={this.props::toggleReturnStatusFacetItems}
                    title='PART_REQUEST_STATUS'
                    valueKey='key'
                />
                <RequestTypeFacet
                    actions={this.props.actions}
                    facets={this.props.facets}
                    isExpanded={this.state.requestTypeExpanded}
                    onClick={this.onAccordionToggle.bind(this, 'requestTypeExpanded')}
                    title='REQUEST_TYPE'
                />
                <FacetsDateRangePickerControlled
                    dateFormat={this.props.facets.requestDateFacet.dateFormat}
                    dateRange={this.props.facets.requestDateFacet.dateRange}
                    isExpanded={this.state.dateRangePickerExpanded}
                    maxDate={this.props.facets.requestDateFacet.maxDate}
                    minDate={this.props.facets.requestDateFacet.minDate}
                    onChange={this.props::onDatePickerChange}
                    onClick={this.onAccordionToggle.bind(this, 'dateRangePickerExpanded')}
                    title='REQUESTED'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet) || !this.props.facets.requestTypes.selectedTypes.length}
                        onApply={this.props::handleApplyFilters}
                        onReset={this.props::handleResetFilters}
                    /> : null}
            </aside>
        );

    }

}

AllPartsReturnsFacets.displayName = 'AllPartsReturnsFacets';
AllPartsReturnsFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired
};

export default AllPartsReturnsFacets;



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/components/all-part-requests-facets.js